import { GroupedCell as t, AggregatedCell as g, GroupedCheckboxCell as o, DefaultCell as u } from "./Row/Cell.js";
const l = {
  grouped: t,
  aggregated: g,
  groupedCheckbox: o,
  default: u,
  empty: () => null
}, p = (e, r) => e.getIsGrouped() ? "grouped" : e.getIsAggregated() ? "aggregated" : r && e.getIsPlaceholder() ? "groupedCheckbox" : e.getIsPlaceholder() ? "empty" : "default";
export {
  l as cellTypeMap,
  p as getCellType
};
//# sourceMappingURL=tools.js.map
